<template>
  <section id="df-news" class="text-justify">
    <img style="width: 100%" src="@/assets/cepSuites/new-logo.png" alt="new-logo" />
    <p>
      {{ $t("content") }}
    </p>
    <img style="width: 100%" src="@/assets/news/logoinfo.png" alt="logoinfo" />
  </section>
</template>
<script>
export default {
  name: "df-news",
};
</script>
<i18n>
{
    "es": {
        "title": "Renovamos nuestro logo",
        "content": "A consecuencia del crecimiento sostenido que hemos vivido en los últimos períodos. A inicios de este 2023 comenzamos a analizar la posibilidad de hacer un cambio de identidad, fue así que decidimos renovar nuestro logo y nuestra imagen corporativa, y este cambio se debe a una evolución permanente que estamos viviendo y al desafío de seguir creciendo y expandiendo nuestros servicios a otras industrias y países."
    },
    "en": {
        "title": "We renew our logo",
        "content": "As a result of the sustained growth that we have experienced in recent periods. At the beginning of this 2023 we began to analyze the possibility of making a change of identity, so we decided to renew our logo and our corporate image, and this change is due to a permanent evolution that we are experiencing and the challenge of continuing to grow and expand our services to other industries and countries."
    },
    "pt": {
        "title": "Renovamos o nosso logótipo",
        "content": "Como resultado do crescimento sustentado que temos experimentado nos últimos períodos. No início deste 2023 começámos a analisar a possibilidade de fazer uma mudança de identidade, pelo que decidimos renovar o nosso logótipo e a nossa imagem corporativa, sendo que esta mudança se deve a uma evolução permanente que estamos a viver e ao desafio de continuar a crescer e expandir nossos serviços para outras indústrias e países."
    }
}
</i18n>
